import { GET_RESOURCES } from './../constants/actionTypes'

const resources = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_RESOURCES:
      return action.data.data
    default:
      return store
  }
}

export default resources
